import { Injectable } from "@angular/core";
import { ClientType } from "./com/comEnvironmentClient";
import { CoreCOMService } from "./com.service";

@Injectable({
  providedIn: "root"
})
export class IOSHelperService {

  constructor(private _coreCOMService: CoreCOMService) { }

  // fixed webview position after keyboard hide.
  public setWebviewAfterBlur() {
    const me = this;
    document.getElementsByTagName("html")[0].style.height = "calc(var(--vh) * 101)";
    setTimeout(() => {
      document.getElementsByTagName("html")[0].style.height = "calc(var(--vh) * 100)";
    }, 100);
  }

  /**set paddingbottom 
 * to solve the problem for IOS device by safe-area-bottom
 */
  public hasSafeArea(): boolean {
    const me = this;
    const isIOS = me._coreCOMService.environment.client.isMobile && me._coreCOMService.environment.client.type === ClientType.ios;
    const safeAreaInsetBottom = parseInt(getComputedStyle(document.body).getPropertyValue("--safe-area-inset-bottom"));
    return isIOS && safeAreaInsetBottom > 0;
  }
}
